export default __webpack_public_path__ + "static/media/OscuraBlackenedSteel_T.e6c712af.jpg";